const mediaDevices = navigator.mediaDevices;
const {
  RTCIceCandidate,
  RTCPeerConnection,
  RTCSessionDescription,
  MediaStream,
  MediaStreamTrack,
} = window;

export {
  MediaStream,
  mediaDevices,
  RTCIceCandidate,
  RTCPeerConnection,
  MediaStreamTrack,
  RTCSessionDescription,
};
